"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialShadowData = void 0;
const AbstractMaterialData_1 = require("./AbstractMaterialData");
class MaterialShadowData extends AbstractMaterialData_1.AbstractMaterialData {
    // #region Constructors (1)
    /**
     * Creates a material data object.
     *
     * @param _attributes the attributes of the material
     * @param id the id
     */
    constructor(properties, id, version) {
        super(properties, id, version);
        if (!properties)
            return;
    }
    // #endregion Constructors (1)
    // #region Public Methods (1)
    reset() {
        this.color = "#000000";
        this.opacity = 1.0;
    }
    clone() {
        return new MaterialShadowData({
            color: this.color,
            opacity: this.opacity,
        }, this.id, this.version);
    }
    copy(source) {
        this.color = source.color;
        this.opacity = source.opacity;
    }
}
exports.MaterialShadowData = MaterialShadowData;
//# sourceMappingURL=MaterialShadowData.js.map